module.exports = __webpack_public_path__ + "static/media/publicGroupIcon.d3cd3f4d.svg";